import React from "react";
import PropTypes from "prop-types";

import ReconciliationRow from "./ReconciliationRow";
import { reconciliationItemShape } from "constants/reconciliationItemShape";

const ReconciliationTitleRow = ({
  displayName,
  classes,
  reconciliationDataFieldName = undefined,
  reconciliationData = undefined,
  underlined = true,
}) => (
  <ReconciliationRow
    displayName={displayName}
    reconciliationDataFieldName={reconciliationDataFieldName}
    reconciliationData={reconciliationData}
    classes={classes}
    insertDivider={false}
    bold
    isNegative={false}
    hasLeftMargin={false}
    hasVerticalSpacing
  />
);

ReconciliationTitleRow.propTypes = {
  displayName: PropTypes.string.isRequired,
  reconciliationDataFieldName: PropTypes.string,
  reconciliationData: PropTypes.shape({
    audited: reconciliationItemShape,
    current: reconciliationItemShape,
    changes: reconciliationItemShape,
    variance: reconciliationItemShape,
    meta: PropTypes.shape({
      isAudited: PropTypes.bool,
    }),
  }),
  // eslint-disable-next-line react/forbid-prop-types -- See financialTableStyles
  classes: PropTypes.object.isRequired,
  underlined: PropTypes.bool,
};

ReconciliationTitleRow.defaultProps = {
  reconciliationDataFieldName: undefined,
  reconciliationData: undefined,
  underlined: true,
};

export default ReconciliationTitleRow;
